import { useMediaQuery } from "@mui/material";
import React, { useRef } from "react";
import { BASE_THEME } from "../../styles/theme";
import DesktopLayout from "./DesktopLayout";
import MobileLayout from "./MobileLayout";
const MainLayout = () => {
    const isMobile = useMediaQuery(BASE_THEME.breakpoints.down("md"));
    const scrollRef = useRef();
    return isMobile ? (React.createElement(MobileLayout, { scrollRef: scrollRef })) : (React.createElement(DesktopLayout, { scrollRef: scrollRef }));
};
export default MainLayout;
